export interface TranslationMessages {
  [key: string]: any;
}

const englishMessages: TranslationMessages = {
  feedback: {
    title: 'Neko Coffee Feedback',
    subtitle: 'Help us improve your coffee shop experience',
    rating: {
      label: 'How would you rate your experience?',
    },
    platform: {
      label: 'Platform',
      dineIn: 'Dine-in',
      delivery: 'Delivery',
      grab: 'Grab',
      shopeeFood: 'Shopee Food',
      xanhSM: 'Xanh SM',
    },
    category: {
      label: 'Category',
      foodBeverage: 'Food & Beverage Quality',
      service: 'Service Experience',
      atmosphere: 'Atmosphere & Ambiance',
      menu: 'Menu Suggestions',
      staff: 'Staff Feedback',
      general: 'General Feedback',
      other: 'Other',
    },
    contact: {
      title: 'Other Contact Channels',
      facebook: 'Facebook Fanpage',
      zalo: 'Zalo',
      hotline: 'Hotline',
      email: 'Email',
      youtube: 'YouTube',
      googleMaps: 'Google Maps',
    },
    orderId: {
      label: 'Order ID',
      grabFormat: 'e.g., GF-12345 or longer Booking ID',
      placeholder: {
        grab: 'Enter your Grab order ID (GF-12345 or Booking ID)',
        'shopee-food': 'Enter your ShopeeFood order ID',
        'xanh-sm': 'Enter your Xanh SM order ID',
      },
      hint: {
        grab: 'You can use either the short format (GF-xx) or the longer Booking ID. Find it in the Grab app or confirmation email',
        'shopee-food': 'You can find your order ID in the ShopeeFood app or confirmation email',
        'xanh-sm': 'You can find your order ID in the Xanh SM app or confirmation email',
      },
    },
    comment: {
      label: 'Your Feedback',
      placeholder: 'We\'d love to hear from you! 💬 Share what you loved, what we can improve, or any suggestions to make your next visit even better...',
    },
    contactInfo: {
      label: 'Contact Info (Mobile/Zalo - Optional)',
      placeholder: 'Enter your phone number or Zalo if you\'d like us to reach out',
    },
    images: {
      label: 'Photos (Optional)',
      upload: 'Add Photos',
      hint: 'You can upload up to 5 photos (max 5MB each)',
      maxReached: 'Maximum 5 photos allowed',
      tooLarge: 'Image is too large. Maximum size is 5MB',
      invalidType: 'Please upload an image file',
    },
    submit: 'Submit Feedback',
    success: {
      title: 'Thank you!',
      message: 'Your feedback has been submitted successfully.',
      ratingMessage: {
        1: 'We\'re sorry to hear about your experience. Your feedback helps us improve, and we\'ll work hard to make it better next time.',
        2: 'Thank you for your feedback. We appreciate you taking the time to share, and we\'ll use this to improve our service.',
        3: 'Thank you for your feedback! We\'re glad you visited, and we\'ll continue working to make your experience even better.',
        4: 'Thank you so much! We\'re thrilled you enjoyed your visit, and we\'ll keep striving to exceed your expectations.',
        5: 'Wow, thank you! 🌟 We\'re so happy you loved your experience! Your kind words mean the world to us.',
      },
    },
    thankYou: {
      backToForm: 'Submit Another Feedback',
    },
  },
};

export default englishMessages;

